import { useRef } from 'react';
import useProductMainImage from '~/hooks/components/use-product-main-image';
import { EnhancedProductLineItem } from '~/utils/use-cart-items';
import LineItemGeneric from './LineItemGeneric';

type Props = {
  item: EnhancedProductLineItem;
  confirmed?: boolean;
};

const ProductLineItem = ({ item, confirmed = false }: Props) => {
  const {
    variant: { sku, slug, optionValues },
    displayAmount,
    quantity,
    id,
    product,
  } = item;
  const lineItemRef = useRef<HTMLDivElement>(null);

  const sizeOption = optionValues?.find((o) => o?.option_type?.[0]?.slug === 'size');
  const colorOption = optionValues?.find((o) => o?.option_type?.[0]?.slug === 'color');
  const priceWithoutDecimal = displayAmount.split('.')[0];

  const { image } = useProductMainImage({ sku, slug });

  return (
    <LineItemGeneric
      ref={lineItemRef}
      image={image}
      title={product?.name}
      size={sizeOption?.presentation}
      color={colorOption?.presentation}
      quantity={quantity}
      id={id}
      optionalShippingNote={item.variant?.optionalShippingNote}
      priceWithoutDecimal={priceWithoutDecimal}
      confirmed={confirmed}
    />
  );
};

export default ProductLineItem;
